import {ReplaySubject} from "rxjs";

export class TabLink {
    private readonly selector = '.js-tab-link';
    private readonly targetSelector = '.js-tab-target';

    private readonly tabTargets: HTMLElement[];
    private triggers: HTMLLinkElement[];
    private clickSubscription = new ReplaySubject<HTMLElement>();
    private activeUiClass = 'is-active';
    constructor() {
        this.triggers = Array.from(document.querySelectorAll(this.selector));

        if (this.triggers.length > 0) {
            this.tabTargets = Array.from(document.querySelectorAll<HTMLElement>(this.targetSelector));
            this.listen();
        }
    }

    private listen() {
        this.triggers.forEach(elem => {
            elem.addEventListener('click', ev => this.onClick(ev));
        })
    }

    getTabTargets() {
        return this.tabTargets;
    }

    /**
     * Get trigger elem pointing to specific target id
     * @param targetId
     */
    getTrigger(targetId: string): HTMLLinkElement {
        return this.triggers.find(t => t.getAttribute('data-target') === targetId);
    }



    private onClick(ev: MouseEvent) {
        const trigger = ev.target as HTMLElement;
        const refId = trigger.getAttribute('data-ref-id');
        const refElem = document.querySelector(`#${refId}`);

        if (!refId || !refElem) {
            return;
        }

        ev.preventDefault();

        const tabId = trigger.getAttribute('data-target');

        this.clickSubscription.next(this.tabTargets.find(tab => tab.getAttribute('data-section-id') === tabId));

        this.toggleActiveClass(trigger);
        this.updateUrl(trigger);
    }

    clicked(): ReplaySubject<HTMLElement> {
        return this.clickSubscription;
    }

    toggleActiveClass(target: HTMLElement): void {
        Array.from(target.parentElement.querySelectorAll(this.selector)).forEach(trigger => trigger.classList.remove(this.activeUiClass));
        target.classList.add(this.activeUiClass);
    }

    private updateUrl(target: HTMLElement): void {
        history.pushState({}, '', (target as HTMLLinkElement).href);
    }
}
